export default __webpack_public_path__ + "static/media/Ballroll_00056.a6644901.png";